// extracted by mini-css-extract-plugin
export default {"wrapper":"CategoryHeader_wrapper__1ifXn"};